'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.hoursBefore;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/number/hoursBefore.js
// module id = 170
// module chunks = 0